export default "__VITE_ASSET__BruMpuKU__"